import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import api from "./api";
import {handleResponseStatus, updateItem, updateIdField} from "./utils";

const initialState = {
    items: [],
    currentlyActive: {},
    createStatus: "idle", // 'idle' | 'loading' | 'success' | 'failed'
    fetchStatus: "idle",// 'idle' | 'loading' | 'success' | 'failed'
    fetchByIdStatus: "idle",// 'idle' | 'loading' | 'success' | 'failed'
    updateStatus: "idle",// 'idle' | 'loading' | 'success' | 'failed'
    deleteStatus: "idle",// 'idle' | 'loading' | 'success' | 'failed'
    pagination: {},
    error: null,
};

export const CreateBank = createAsyncThunk('setting/CreateBank', async ({roleSign, data}) => {
    try {
        const response = await api.post(`/${roleSign}/accounts`, data);
        return {...response}
    } catch (error) {
        if (error.response) return error.response;
        throw error;
    }
});

export const fetchAllBanks = createAsyncThunk('setting/fetchAllBanks', async ({roleSign, scopeId}) => {
    try {
        const response = await api.get(`/${roleSign}/accounts?id=${scopeId}`);
        return {...response}
    } catch (error) {
        if (error.response) return error.response;
        throw error;
    }
});

export const fetchBankById = createAsyncThunk('setting/fetchBankById', async ({roleSign, id}) => {
    try {
        const response = await api.get(`/${roleSign}/accounts/${id}`);
        return {...response}
    } catch (error) {
        if (error.response) return error.response;
        throw error;
    }
});

export const UpdateBank = createAsyncThunk('setting/UpdateBank', async ({roleSign, id, data}) => {
    try {
        const response = await api.patch(`/${roleSign}/accounts/${id}`, data);
        return {...response}
    } catch (error) {
        if (error.response) return error.response;
        throw error;
    }
});

export const deleteBank = createAsyncThunk('setting/deleteBank', async ({id, scopeId, roleSign, accountNumber}) => {
    try {
        const response = await api.delete(`/${roleSign}/accounts/delete?id=${scopeId}&accountNumber=${accountNumber}`);
        return {...response};
    } catch (error) {
        if (error.response) return error.response;
        throw error;
    }
});

const bankSettingSlice = createSlice({
    name: "bankSetting",
    initialState: initialState,
    reducers: {
        resetUpdateStatus(state) {
            state.updateStatus = 'idle';
        },
        resetDeleteStatus(state) {
            state.deleteStatus = 'idle';
        },
        resetCreateStatus(state) {
            state.createStatus = 'idle';
        },
    },
    extraReducers(builder) {
        builder
            // fetch all banks
            .addCase(fetchAllBanks.pending, (state) => {
                state.fetchStatus = 'loading';
            })
            .addCase(fetchAllBanks.fulfilled, (state, action) => {
                const {fetchStatus, error} = handleResponseStatus(action.payload, 'fetchStatus');
                const {data, ...pagination} = action.payload.data;
                state.items = fetchStatus === "success" ? updateIdField(data) : state.items;
                state.fetchStatus = fetchStatus;
                state.pagination = pagination;
                state.error = error;
            })
            .addCase(fetchAllBanks.rejected, (state, action) => {
                state.fetchStatus = 'failed';
                state.error = action.error.message;
            })

            // fetch bank by id
            .addCase(fetchBankById.pending, (state) => {
                state.fetchByIdStatus = 'loading';
            })
            .addCase(fetchBankById.fulfilled, (state, action) => {
                const {fetchByIdStatus, error} = handleResponseStatus(action.payload, 'fetchByIdStatus');
                state.items = fetchByIdStatus === "success" ? updateItem(action.payload.data.data, state.items) : state.items;
                state.fetchByIdStatus = fetchByIdStatus;
                state.error = error;
            })
            .addCase(fetchBankById.rejected, (state, action) => {
                state.fetchByIdStatus = 'failed';
                state.error = action.error.message;
            })

            // Create bank
            .addCase(CreateBank.pending, (state) => {
                state.createStatus = 'loading';
            })
            .addCase(CreateBank.fulfilled, (state, action) => {
                const {createStatus, error} = handleResponseStatus(action.payload, 'createStatus');
                state.createStatus = createStatus;
                state.error = error;
            })
            .addCase(CreateBank.rejected, (state, action) => {
                state.createStatus = 'failed';
                state.error = action.error.message;
            })

            // update bank
            .addCase(UpdateBank.pending, (state) => {
                state.updateStatus = 'loading';
            })
            .addCase(UpdateBank.fulfilled, (state, action) => {
                const {updateStatus, error} = handleResponseStatus(action.payload, 'updateStatus');
                state.updateStatus = updateStatus;
                state.error = error;
            })
            .addCase(UpdateBank.rejected, (state, action) => {
                state.updateStatus = 'failed';
                state.error = action.error.message;
            })

            // delete bank
            .addCase(deleteBank.pending, (state) => {
                state.deleteStatus = 'loading';
            })
            .addCase(deleteBank.fulfilled, (state, action) => {
                const {deleteStatus, error} = handleResponseStatus(action.payload, 'deleteStatus');
                state.deleteStatus = deleteStatus;
                state.items = state.items.filter((item) => item.id !== action.payload.data.data._id);
                state.error = error;
            })
            .addCase(deleteBank.rejected, (state, action) => {
                state.deleteStatus = 'failed';
                state.error = action.error.message;
            });
    }
});

export const {
    resetUpdateStatus, resetDeleteStatus, resetCreateStatus
} = bankSettingSlice.actions;

export default bankSettingSlice.reducer;


